export default function ISTJ(props) {
  return (
    <div className="row">
      <div className="col-12 p-5">
        <article className="main description">
          <h1>شخصیت “تدارکاتچی”</h1>{" "}
          <blockquote>
            <p>
              به نظر من هر وقت مشخص شود یک نفر برای انجام یک وظیفه کفایت
              می&zwnj;کند ... آن کار توسط دو نفر بدتر انجام می&zwnj;شود، و اگر
              سه نفر یا بیشتر به کار گرفته شوند، اساساً انجام نخواهد شد.
            </p>{" "}
            <footer>George Washington</footer>
          </blockquote>{" "}
          <p>
            تصور می&zwnj;شود که گونه شخصیتی تدارکچی فراوان&zwnj;ترین گونه بوده و
            حدود 13% از جمعیت را تشکیل دهد. ویژگی&zwnj;های معرف تدارکچیان یعنی
            صداقت، منطق عملی و تلاش&zwnj;های خستگی&zwnj;ناپذیر برای انجام وظیفه
            آنها را به هسته اصلی بسیاری از خانواده&zwnj;ها و همچنین
            سازمان&zwnj;هایی تبدیل می&zwnj;کند که حامی سنت&zwnj;ها، قوانین و
            استانداردها هستند، مانند سازمان&zwnj;های قضایی، نهادهای نظارتی و
            ارتش. افراد دارای گونه شخصیتی تدارکچی از برعهده گرفتن مسئولیت اعمال
            خود لذت می&zwnj;برند و به کاری که انجام می&zwnj;دهند افتخار
            می&zwnj;کنند - تدارکچیان در هنگام تلاش برای رسیدن به هدف از وقت و
            انرژی خود برای تمام کردن کار مربوط با دقت و صبر دریغ نمی&zwnj;کنند.
          </p>{" "}
          <p>
            تدارکچیان فرضیات زیادی ندارند و ترجیح می&zwnj;دهند بجای تجزیه و
            تحلیل محیط اطراف خود، حقایق را بررسی کرده و به کارهای عملی مشغول
            شوند. شخصیت تدارکچی&zwnj;ها به هیچ عنوان بی&zwnj;معنا نیست و وقتی
            تصمیمی بگیرند حقایق لازم برای رسیدن به هدف خود را به دیگران منتقل
            می&zwnj;کنند و از دیگران انتظار دارند بلافاصله وضعیت را درک کرده و
            دست به اقدام بزنند. تدارکچیان تحمل کمی نسبت به عدم تصمیم&zwnj;گیری
            دارند، اما چنانچه روش انتخاب شده با نظریه&zwnj;های غیرعملی به چالش
            کشیده شود با سرعت بیشتری تحمل خود را از دست می&zwnj;دهند، به خصوص
            اگر جزئیات کلیدی نادیده گرفته شود - اگر چالش&zwnj;ها به
            بحث&zwnj;هایی وقتگیر تبدیل شوند افراد دارای گونه شخصیتی تدارکچی با
            نزدیک شدن مهلت به طرز محسوسی عصبانی&zwnj;تر می&zwnj;شوند.
          </p>{" "}
          <h2>اگر برای شهرت خود ارزش قائل هستی با افراد خوب همنشین باش...</h2>{" "}
          <p>
            هنگامی که تدارکچیان می&zwnj;گویند قصد دارند کاری را به انجام
            برسانند، این کار را انجام می&zwnj;دهند و تعهدات خود را بدون توجه به
            هزینه&zwnj;های شخصی برآورده می&zwnj;کنند و از رفتار کسانی که به همان
            ترتیب به وعده خود عمل نمی&zwnj;کنند گیج می&zwnj;شوند. ترکیب تنبلی و
            عدم صداقت سریع&zwnj;ترین راه برای عصبانی کردن تدارکچیان است. در
            نتیجه، مردم دارای گونه شخصیتی تدارکچی اغلب ترجیح می&zwnj;دهند به
            تنهایی کار کنند، یا حداقل سلسله مراتب قدرت مشخصی داشته باشند، تا
            بدون بحث یا نگرانی در مورد قابل اعتماد بودن دیگران اهدافشان را تعیین
            کرده و به آنها دست یابند.
          </p>{" "}
          <p>
            شخصیت&zwnj;های تدارکچی دارای ذهن تیز و مبتنی بر واقعیت هستند و
            استقلال و خودکفایی را به وابستگی به کسی یا چیزی ترجیح می&zwnj;دهند.
            وابستگی به دیگران اغلب به نظر تدارکچیان نوعی نقطه ضعف تلقی
            می&zwnj;شود، و اشتیاق آنها به انجام وظیفه، قابلیت اعتماد و صداقت
            شخصی تمام و کمال از افتادن آنها در چنین دامی جلوگیری می&zwnj;کند.
          </p>{" "}
          <p>
            این احساس کمال شخصی برای تدارکچیان اساسی است، و از ذهنشان فراتر
            می&zwnj;رود - شخصیت&zwnj;های تدارکچی به قوانین و دستورالعمل&zwnj;های
            تعیین شده صرف نظر از هزینه آن پایبند هستند، اشتباه&zwnj;های خود را
            گزارش می&zwnj;دهند و حقیقت را می&zwnj;گویند حتی زمانی که عواقب انجام
            این کار برایشان فاجعه&zwnj;آمیز باشد. از نظر تدارکچیان، صداقت به
            مراتب مهم&zwnj;تر از ملاحظات عاطفی است، و رویکرد فاقد انعطاف آنها
            ممکن است در دیگران این تصور غلط را به وجود بیاورد که تدارکچیان سرد،
            یا حتی روبات&zwnj;مانند هستند. افراد دارای این گونه شخصیتی اغلب تلاش
            می&zwnj;کنند احساسات یا محبت را آشکار را بیان کنند، اما این جمله که
            فاقد احساس هستند، یا بدتر اینکه اصلاً همدلی ندارند، عمیقاً دردناک
            است.
          </p>{" "}
          <h2>... چرا که تنها بودن بهتر از داشتن دوستان بد است</h2>{" "}
          <p>
            فداکاری تدارکچیان، یک ویژگی عالی است که به این شخصیت&zwnj;ها اجازه
            می&zwnj;دهد کارهای زیادی را به انجام برسانند، اما در عین حال ضعف
            مهمی نیز هست چرا که افراد کم&zwnj;صداقت ممکن است از آن سوءاستفاده
            کنند. تدارکچیان به دنبال ثبات و امنیت هستند و وظیفه خود
            می&zwnj;دانند تا روال کارها را حفظ کنند و ممکن است متوجه شوند که
            همکاران و افراد دیگر بخش قابل توجهی از مسئولیت&zwnj;های خود را بر
            دوش آنها انداخته&zwnj;اند، چرا که می&zwnj;دانند آنها همیشه کارهای
            زمین مانده را انجام می&zwnj;دهند. افراد دارای گونه شخصیتی تدارکچی
            معمولاً نظراتشان را برای خودشان نگه می&zwnj;دارند و اجازه دهید
            واقعیت&zwnj;ها خود همه چیز را نشان دهند، اما ممکن است خیلی طول بکشد
            تا شواهد ملموس کل قضیه را نشان دهند.
          </p>{" "}
          <p>
            تدارکچیان باید به یاد داشته باشند که از خود مراقبت کنند - تعهد
            سرسختانه آنها به ثبات و کارآمدی می&zwnj;تواند در دراز مدت به این
            اهداف ضربه بزند زیرا دیگران همیشه بیش از پیش به آنها اتکا
            می&zwnj;کنند، موجب ایجاد فشار احساسی می&zwnj;شوند که ممکن است
            سال&zwnj;های سال ابراز نشود، و در نهایت وقتی گفته شود که برطرف کردن
            آن خیی دیر باشد. اگر شخصیت&zwnj;های تدارکچی بتوانند همکاران و
            همسرانی پیدا کنند که واقعاً قدردان و مکمل ویژگی&zwnj;های آنها باشند
            و از وضوح، شفافیت و اعتمادی که آنها ارائه می&zwnj;کنند بهره&zwnj;مند
            شوند، در این صورت متوجه خواهند شد که نقش ثبات&zwnj;آور آنها
            فوق&zwnj;العاده رضایت&zwnj;بخش است زیرا می&zwnj;دانند بخشی از سیستمی
            هستند که در آن کار می&zwnj;کنند.
          </p>
        </article>
      </div>
    </div>
  );
}
